/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ListNurseryEventTypeConfigsResponseDto,
  UpdateNurseryEventTypeConfigDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Replaces both role lists for this nursery and event type. A full payload, not a partial update: send both lists every time. Group admins only — nursery managers cannot change who reviews their own work.
 * @summary Set one event type's acknowledgement rules for a nursery (group admins only)
 */
export const updateNurseryEventTypeConfigCommandControllerUpdate = (
  nurseryId: string,
  eventTypeId: string,
  updateNurseryEventTypeConfigDto: UpdateNurseryEventTypeConfigDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/event-type-configs/${eventTypeId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateNurseryEventTypeConfigDto,
    signal,
  });
};

export const getUpdateNurseryEventTypeConfigCommandControllerUpdateMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateNurseryEventTypeConfigCommandControllerUpdate>
      >,
      TError,
      {
        nurseryId: string;
        eventTypeId: string;
        data: UpdateNurseryEventTypeConfigDto;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateNurseryEventTypeConfigCommandControllerUpdate>
    >,
    TError,
    {
      nurseryId: string;
      eventTypeId: string;
      data: UpdateNurseryEventTypeConfigDto;
    },
    TContext
  > => {
    const mutationKey = ["updateNurseryEventTypeConfigCommandControllerUpdate"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateNurseryEventTypeConfigCommandControllerUpdate>
      >,
      {
        nurseryId: string;
        eventTypeId: string;
        data: UpdateNurseryEventTypeConfigDto;
      }
    > = (props) => {
      const { nurseryId, eventTypeId, data } = props ?? {};

      return updateNurseryEventTypeConfigCommandControllerUpdate(
        nurseryId,
        eventTypeId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateNurseryEventTypeConfigCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateNurseryEventTypeConfigCommandControllerUpdate>
    >
  >;
export type UpdateNurseryEventTypeConfigCommandControllerUpdateMutationBody =
  UpdateNurseryEventTypeConfigDto;
export type UpdateNurseryEventTypeConfigCommandControllerUpdateMutationError =
  void;

/**
 * @summary Set one event type's acknowledgement rules for a nursery (group admins only)
 */
export const useUpdateNurseryEventTypeConfigCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateNurseryEventTypeConfigCommandControllerUpdate>
      >,
      TError,
      {
        nurseryId: string;
        eventTypeId: string;
        data: UpdateNurseryEventTypeConfigDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateNurseryEventTypeConfigCommandControllerUpdate>
  >,
  TError,
  {
    nurseryId: string;
    eventTypeId: string;
    data: UpdateNurseryEventTypeConfigDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateNurseryEventTypeConfigCommandControllerUpdateMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Returns who must acknowledge and who may mark resolved for every active event type. Types the nursery has never configured come back with the platform defaults and isDefault: true, so the rules screen never has to guess what the server would fall back to.
 * @summary A nursery's event acknowledgement rules, one entry per active event type
 */
export const listNurseryEventTypeConfigsQueryControllerList = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ListNurseryEventTypeConfigsResponseDto>({
    url: `/v1/nurseries/${nurseryId}/event-type-configs`,
    method: "GET",
    signal,
  });
};

export const getListNurseryEventTypeConfigsQueryControllerListQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/event-type-configs`] as const;
};

export const getListNurseryEventTypeConfigsQueryControllerListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListNurseryEventTypeConfigsQueryControllerListQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>>
  > = ({ signal }) =>
    listNurseryEventTypeConfigsQueryControllerList(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNurseryEventTypeConfigsQueryControllerListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>>
  >;
export type ListNurseryEventTypeConfigsQueryControllerListQueryError = void;

export function useListNurseryEventTypeConfigsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseryEventTypeConfigsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseryEventTypeConfigsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary A nursery's event acknowledgement rules, one entry per active event type
 */

export function useListNurseryEventTypeConfigsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryEventTypeConfigsQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListNurseryEventTypeConfigsQueryControllerListQueryOptions(
      nurseryId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
